import randomString from "./randomString"

export default function (
  baseURL: string,
  newRandomNumber: (depID: number) => number,
) {
  const cacheBuster = `rnd=${randomString(20, newRandomNumber)}`
  return `${baseURL}?${cacheBuster}`
}
